import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DOCUMENT, Location } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ENVIRONMENT, Environment } from '@environment';
import { CompetitionsService } from '@usheru-hff/movie-detail/feature-competitions';
import { ChannelService } from '@usheru-hff/sdk/channel';
import { LocationService } from '@usheru-hff/sdk/location';
import { MovieService } from '@usheru-hff/sdk/movie';
import { NavigationService } from '@usheru-hff/sdk/navigation';
import { TRACKING_SERVICE, TrackingService } from '@usheru-hff/sdk/tracking';
import { VideoFullscreenService } from '@usheru-hff/shared/ui-video';
import { TemplatesService, BrandedPageThemeService } from '@usheru-hff/shared/utils';
import { CookieSettingsService } from '@usheru-hff/shared/utils-cookies';
import { ImageService } from '@usheru-hff/shared/utils-image';
import { MetatagsService } from '@usheru-hff/shared/utils-metatag';
import { ShowtimeStreamingService } from '@usheru-hff/shared/utils-movie';
import { PageLoaderService } from '@usheru-hff/shared/utils-navigation';
import { TitleService } from '@usheru-hff/shared/utils-title';
import { TranslationsService } from '@usheru-hff/shared/utils-translation';
import { UplayerService } from '@usheru-hff/uplayer/domain';

import { BrandedMovieTemplate } from '../branded-movie-template';
import { templateMenuTranslations } from '../movie-template-menu.translations';

@Component({
    selector: 'ush-movie-template-a',
    templateUrl: './movie-template-a.component.html',
    styleUrls: ['./movie-template-a.component.scss'],
    standalone: false
})
export class MovieTemplateAComponent extends BrandedMovieTemplate implements OnInit {
  isMobile$: Observable<boolean>;

  constructor(
    @Inject(ENVIRONMENT) private env: Environment,
    @Inject(PLATFORM_ID) public platform,
    public override channelService: ChannelService,
    public override movieService: MovieService,
    public override brandedPageThemeService: BrandedPageThemeService,
    public override titleService: TitleService,
    public override videPlayerService: VideoFullscreenService,
    public override metaTagService: MetatagsService,
    public override imageService: ImageService,
    public override route: ActivatedRoute,
    public override router: Router,
    public override location: Location,
    public override translationsService: TranslationsService,
    public override locationService: LocationService,
    public override navigationService: NavigationService,
    public override templatesService: TemplatesService,
    @Inject(TRACKING_SERVICE) public override trackingService: TrackingService,
    public override competitionsService: CompetitionsService,
    public override pageLoader: PageLoaderService,
    public override cookiesService: CookieSettingsService,
    public override sanitizer: DomSanitizer,
    public override uplayerService: UplayerService,
    public override cd: ChangeDetectorRef,
    public override showtimeStreamingService: ShowtimeStreamingService,
    private breakpointObserver: BreakpointObserver,
    @Inject(DOCUMENT) public document: Document
  ) {
    super(
      env,
      platform,
      channelService,
      movieService,
      brandedPageThemeService,
      titleService,
      videPlayerService,
      metaTagService,
      imageService,
      route,
      router,
      location,
      translationsService,
      locationService,
      navigationService,
      templatesService,
      trackingService,
      competitionsService,
      pageLoader,
      cookiesService,
      sanitizer,
      uplayerService,
      cd,
      showtimeStreamingService,
      document
    );
  }

  ngOnInit() {
    this.isMobile$ = this.breakpointObserver.observe([Breakpoints.Handset]).pipe(map(result => result.matches));
    super.ngOnInit();
  }

  translateMenu(key: string): string {
    return templateMenuTranslations[key] || key;
  }
}
